import SingleMediaUploader from './SingleMediaUploader.vue'
import SingleFileInput from './SingleFileInput.vue'
import MultipleFileInput from './MultipleFileInput.vue'
import FileUploader from './FileUploader.vue'
import Preloader from './Preloader.vue'
import Checkbox from './Checkbox.vue'
import RichTextarea from './RichTextarea.vue'

import SimpleCard from './SimpleCard.vue'
import Datatable from './Datatable.vue'
import Mailbox from './Mailbox.vue'
import Sortable from './Sortable.vue'
import Flash from './Flash.vue'

import ToggleOptionElement from './DatatableElements/ToggleOptionElement.vue'
import DeleteElement from './DatatableElements/DeleteElement.vue'

export default {
  ToggleOptionElement,
  DeleteElement,
  SingleFileInput,
  MultipleFileInput,
  SingleMediaUploader,
  FileUploader,
  Preloader,
  Datatable,
  Mailbox,
  SimpleCard,
  Checkbox,
  RichTextarea,
  Sortable,
  Flash
}



// WEBPACK FOOTER //
// ./src/components/ui/index.js